<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>통관안내</h3>
			</div>
			<div class="type-card">
				<h5>
					<span class="num">01.</span>
					<div class="content">통관종류</div>
				</h5>
				
				<table class="table-form" border="1" cellspacing="0" style="border-color: #eee;">
					<colgroup>
						<col width="20%">
						<col width="30%">
						<col>
					</colgroup>
					<tbody>
					<tr>
						<th>목록통관</th>
						<td>
							<ul class="dot-list">
								<li>● 자가사용 $150 미만</li>
								<li>● 수입신고 생략</li>
								<li>● 면세</li>
							</ul>
						</td>
						<td>
							<ul class="dot-list">
								<li>● 전자기기는 모델별 1개</li>
								<li>
									● 품목당 신고수량이 많을 경우 일반(간이)통관으로 변경 될수 있습니다
								</li>
								<li>
									● 세관장의 판단에 의해 일반(간이)통관으로 변경 혹은 통관 취하 될수 있습니다
								</li>
							</ul>
						</td>
					</tr>
					<tr>
						<th>일반(간이)통관</th>
						<td>
							<ul class="dot-list">
								<li>● 목록통관 배제대상</li>
								<li>● $150 이상</li>
								<li>● 수입신고</li>
								<li>● 관부가세 적용</li>
							</ul>
						</td>
						<td>
							<ul class="dot-list">
								<li>● 전자기기는 모델별1개</li>
								<li>● 품명,수량,가격등 정보가 부정확 하게
									기재된 경우</li>
								<li>● 목록통관배제 품목이 포함되어 있을경우</li>
								<li>● 세관장의 판단에 의해 통관취하 혹은 사업자 통관으로 변경 될수 있습니다</li>
							</ul>
						</td>
					</tr>
					<tr>
						<th>사업자통관</th>
						<td>
							<ul class="dot-list">
								<li>● 사업자 영리목적으로 수입</li>
								<li>● 수입신고</li>
								<li>● 관부가세 적용</li>
							</ul>
						</td>
						<td>
							<ul class="dot-list">
								<li>● 판매목적으로 수입시 품목별 필수 인증이 필요할수 있으니 수입전 확인 바랍니다</li>
								<li>● 모든 수입물품에는 원산지 표기가 있어야 합니다</li>
								<li>● 통관수수료,관부가세,창고료,국내운송료가 청구 될수 있습니다</li>
								<li>● 세관장의 판단에 의해 통관취하 혹은 사업자 통관으로 변경 될수 있습니다</li>
							</ul>
						</td>
					</tr>
					<tr>
						<th>LCL/FCL 사업자통관</th>
						<td >
							<ul class="dot-list">
								<li>● 사업자 영리목적으로 수입</li>
								<li>● 수입신고</li>
								<li>● 관부가세 적용</li>
							</ul>
						</td>
						<td>
							<ul class="dot-list">
								<li>● 판매목적으로 수입시 품목별 필수 인증이 필요할수 있으니 수입전 확인 바랍니다</li>
								<li>● 모든 수입물품에는 원산지 표기가 있어야 합니다</li>
								<li>● 통관수수료,관부가세,창고료,국내운송료가 청구 될수 있습니다</li>
								<li>● 세관장의 판단에 의해 통관취하 혹은 사업자 통관으로 변경 될수 있습니다</li>
							</ul>
						</td>
					</tr>
					</tbody>
				</table>
				<h5 class="mb10">
					<span class="num">02.</span>
					<div class="content">관 · 부가세 안내</div>	
				</h5>
				<p class="background-color">세관을 통과하는 물품에 대하여 면세범위를 초과하여 국내로 반입 통관 시 발생되는 세금이예요.</p>
				
				<div class="card-body">
					<h6>1. 관 · 부가세란?</h6>
					<div class="mt5">●	관세는 국가가 재정 수입을 어디 위하여 관세 영역을 출입하는 물품에 대하여 법률이나 조약에 의하여 징수하는 세금입니다.</div>
					<div class="mt5">●	과세가격(FOB기준)은 국내에 입향 전까지 물품에 드는 모든 비용을 말하며, 물품 가액이 USD기준으로 150달러가 초과하게 되면 관 · 부가세가 부가됩니다.
					<br><span class="color-grey">(2015년 12월 1일부터 적용)</span>
					<br>물품 가액이 USD기준으로 150달러 미만인 경우로 자가 사용이 인정되는 경우는 관 · 부가세가 면제됩니다.
					<br>물품가액(FOB금액) = 상품가 + 현지운송비 + 현지 TAX
					</div>
					<div class="mt5">●	<strong>과세가격</strong>은 아래와 같습니다.</div>
					<div class="text-box text-center mb20">해외구매가격 <br class="visible-xs">(상품가 + 현지운송비 + 현지세금) <br class="visible-xs">x 관세청 고시환율 + 과세운임</div>
					<p class="color-grey">※ 과세운임은 물품의 구입시 결제금액이 20만원 이하일 경우에는 선편 일반소포과세운임이 적용되며, 20만원을 초과하는 경우에는 특급탁송화물운임이 적용됩니다. </p>	
				</div>
				
				<div class="card-body">
					<h6>2. 합산과세</h6>
					<div class="mt5">●	동일 입항일(한국 도착일)에 2건 이상의 물품이 도착하는 경우, 각 물품의 과세가격이 150달러 이하여도 물품의 총 과세표준가격을 기준으로 하여 합산과세가 발생할 수 있습니다.</div>
					<div class="mt5">●	입항일(한국 도착일)은 다르나 2건 이상의 물품을 같은 날짜에 구입한 경우, 각 물품의 과세가격이 150달러 이하여도 물품의 총 과세효준 가격을 기준으로 하여 합산과세가 발생할 수 있습니다.</div>		
				</div>
				
				<div class="divided-line type-solid"></div>
				
				<h5 class="mb10">
					<span class="num">03.</span>
					<div class="content">통관 보류</div>	
				</h5>
				<p class="mb20 background-color">통관 보류는 세관에서 고객님의 물품을 직접 개봉해서 확인 및 검사를 진행 후<br class="hidden-xs">
				문제 소지가 있어 보이는 상품 또는 기타 확인사항이 필요한 경우 통관을 보류합니다.</p>
				<p class="mb20 background-color">통관이 보류된 상태에서 다시 목록 통관으로 재신고가 불가능하며, 간이통관으로만 재진행이 가능하여 간이통관 수수료가 추가로 발생됩니다.</p>
				
				<div class="process-wrap mb20">
					<ul class="process step-6 mb20">
						<li>
							<div class="step">STEP 1</div>
							<p>
								고로켓고 메세지함으로<br>
								보류 사유 안내
							</p>
						</li>
						<li>
							<div class="step">STEP 2</div>
							<p>
								수수료 고로켓고으로<br>
								납부 및 관련 서류 제출
							</p>
						</li>
						<li>
							<div class="step">STEP 3</div>
							<p>
								제출해주신 서류는<br>
								고로켓고에서 관세사로 전달
							</p>
						</li>
						<li>
							<div class="step">STEP 4</div>
							<p>
								관세사에서 세관 신고 및<br>
								세관에서 검토
							</p>
						</li>
						<li>
							<div class="step">STEP 5</div>
							<p>통관 완료</p>
						</li>
						<li>
							<div class="step">STEP 6</div>
							<p>택배 인계</p>
						</li>
					</ul>
					<p class="text-center mb0">각 취하건은 통관 재진행 시 상황에 따라 추가시간 소요 및 수수료가 발생될 수 있습니다.</p>
				</div>
				<h6 style="font-size: 16px;" class="background-color">보류(취하) 사유 예시 : 지식 재산권(지재권)</h6>
				<div class="mt5 background-color">●	특허법(브랜드), 상표법, 디자인 보호법 등에 해당되는 상품들을 지식재산권이라 합니다.</div>
				<div class="mt5 background-color">●	가품, 디자인 카피(유사)상품 등과 같이 지식재산권을 침해하는 상품이 발견되는 경우, 통관이 보류(취하)될 수 있습니다.</div>
				
				<h5 class="mb20" style="padding:20px 0 10px;">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12ZM18.045 7.455C17.9379 7.34823 17.8103 7.26416 17.6699 7.20782C17.5295 7.15149 17.3792 7.12404 17.228 7.12712C17.0768 7.1302 16.9277 7.16375 16.7897 7.22575C16.6518 7.28776 16.5277 7.37695 16.425 7.488L11.2155 14.1255L8.076 10.9845C7.86274 10.7858 7.58067 10.6776 7.28922 10.6827C6.99776 10.6879 6.71969 10.8059 6.51357 11.0121C6.30745 11.2182 6.18938 11.4963 6.18424 11.7877C6.1791 12.0792 6.28728 12.3612 6.486 12.5745L10.455 16.545C10.5619 16.6517 10.6892 16.7358 10.8294 16.7923C10.9695 16.8487 11.1196 16.8764 11.2706 16.8736C11.4217 16.8708 11.5706 16.8376 11.7085 16.776C11.8465 16.7144 11.9706 16.6256 12.0735 16.515L18.0615 9.03C18.2656 8.81775 18.3784 8.53391 18.3756 8.23944C18.3728 7.94496 18.2546 7.66332 18.0465 7.455H18.045Z" fill="#274A80"></path>
					</svg>
					<div class="content">취하절차</div>
				</h5>
				<p class="background-color"><strong>1) 전량 폐기시</strong></p>
				<div class="process-wrap mb20">
					<ul class="process step-4">
						<li>
							<div class="step">STEP 1</div>
							<p>
								보류 사유 고로켓고<br>
								메세지함으로 안내
							</p>
						</li>
						<li>
							<div class="step">STEP 2</div>
							<p>폐기동의서 고로켓고 제출</p>
						</li>
						<li>
							<div class="step">STEP 3</div>
							<p>운송사 전달</p>
						</li>
						<li>
							<div class="step">STEP 4</div>
							<p>전량폐기 진행</p>
						</li>
					</ul>
				</div>
				<p class="background-color"><strong>2) 일부 폐기(상품분할)</strong></p>
				<div class="mt5 background-color">발생 수수료</div>
				<div class="mt5 background-color">●	전량 폐기 시 : 수수료 없음</div>
				<div class="mt5 background-color">●	일부 폐기 시 : 폐기수수료 5,500원 + 카분할 수수료 5,500원</div>
				<div class="process-wrap mb50">
					<ul class="process step-5 mb20">
						<li>
							<div class="step">STEP 1</div>
							<p>
								보류 사유 고로켓고<br>
								메세지함으로 안내
							</p>
						</li>
						<li>
							<div class="step">STEP 2</div>
							<p>폐기동의서 고로켓고 제출<br>
								<small>(제출 기한이 늦어지는 경우 세관 창고 보관료 금액이 발생 될 수 있습니다.)</small>
							</p>
						</li>
						<li>
							<div class="step">STEP 3</div>
							<p>관세사 전달</p>
						</li>
						<li>
							<div class="step">STEP 4</div>
							<p>폐기 상품과<br>
								배송가능한 상품 분할</p>
						</li>
						<li>
							<div class="step">STEP 5</div>
							<p>통관진행</p>
						</li>
					</ul>
					<p class="text-center">
						고로켓고에서 안내드리는 지적재산권 침해상품(브랜드,상표,디자인) 외에 추가적으로 침해 상품이 발견되는 경우,<br class="hidden-xs">
						해당 상품까지 함께 폐기가 진행되오니, 이 점 유의하여 주시기 바랍니다.
					</p>
				</div>
				
				<h5 class="mb20" style="padding:20px 0 10px;">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12ZM18.045 7.455C17.9379 7.34823 17.8103 7.26416 17.6699 7.20782C17.5295 7.15149 17.3792 7.12404 17.228 7.12712C17.0768 7.1302 16.9277 7.16375 16.7897 7.22575C16.6518 7.28776 16.5277 7.37695 16.425 7.488L11.2155 14.1255L8.076 10.9845C7.86274 10.7858 7.58067 10.6776 7.28922 10.6827C6.99776 10.6879 6.71969 10.8059 6.51357 11.0121C6.30745 11.2182 6.18938 11.4963 6.18424 11.7877C6.1791 12.0792 6.28728 12.3612 6.486 12.5745L10.455 16.545C10.5619 16.6517 10.6892 16.7358 10.8294 16.7923C10.9695 16.8487 11.1196 16.8764 11.2706 16.8736C11.4217 16.8708 11.5706 16.8376 11.7085 16.776C11.8465 16.7144 11.9706 16.6256 12.0735 16.515L18.0615 9.03C18.2656 8.81775 18.3784 8.53391 18.3756 8.23944C18.3728 7.94496 18.2546 7.66332 18.0465 7.455H18.045Z" fill="#274A80"></path>
					</svg>
					<div class="content">취하 종류</div>
				</h5>
				<h4 class="background-color">1. 수량 취하</h4>
				<div class="mt5 mb10 background-color">●	개인통관 시 신청서의 단일 품목 상품이 많은 경우, 등록된 아이템 수량이 많은 경우, 자가사용 목적으로 판단되지 않는 경우 등
				<br>세관원의 재량에 따라 통관이 취하될 수 있습니다. 
				</div>
				<h4 class="background-color">2. 빈번 취하</h4>
				<div class="mt5 mb10 background-color">●	똑같은 상품, 비슷한 유형의 상품들 자주 또는 주기적으로 수입 시 세관원 판단에 따라 통관이 취하될 수 있습니다. </div>
				<h4 class="background-color">3. 가격 취하</h4>
				<div class="mt5 background-color">●	신청서에 작성해주신 가격과 실제 구매 가격이 다르다고 판단되는 경우, 통관이 취하될 수 있습니다. </div>
				<div class="mt5 background-color">●	실제 상품 가격과 달리, 상품의 가격을 낮추어 부과되는 관부가세를 회피하려는 행위를 언더밸류라고 하며 언더밸류로 신청서 작성 후 적발시 불이익 및 과태료, 통관 지연으로 인한 세관 창고 보관료 등 추가 금액이 부과되실 수 있사오니 이 점 유의하여 주시기 바랍니다. </div>
				<div class="mt5 background-color">●	구매 내역 상의 총 금액과 결제 내역의 총 금액이 일치하지 않을 시 통관이 지속적으로 보류되오니, 당시 구매 내역과 결제 내역의 금액을 꼭 확인해주시기 바랍니다. </div>
				<div class="mt5 mb10 background-color">●	언더밸류 적발 시 : 과태료(100,000원~300,000원) </div>
				<h4 class="background-color">4. 합산 취하</h4>
				<div class="mt5 background-color">●	동일한 수취인 명의로 작성된 2건 이상의 신청서 상품이 동일한 날짜에 입항되는 경우 합산과세가 발생합니다. </div>
				<div class="mt5 background-color">●	국제 배송비 결제 전 배송 스케줄을 확인하여 주시기 바라며, 같은 날 도착된 물품 중 발송 국가가 다른 경우 합산되지 않습니다. 
				<br><span class="color-grey">예) 중국에서 오는 상품 900 CNY + 미국에서 오는 상품 100$</span>
				</div>
				<div class="mt5 mb10">●	단, 타오바오 구매 날짜가 다른 경우 면세로 처리 요청이 가능하며, 모든 상품의 구매 내역 및 결제 내역을 1:1 문의로 전달하여 주시기 바랍니다 
				<br><span class="color-grey">예) 신청서 0000 (1월 1일 구매) + 신청서 0000 (1월 2일 구매) 면세로 재진행 요청 가능</span>
				<br><span class="color-grey">신청서 0000 (1월 1일 구매) + 신청서 0000 (1월 1일 구매) 면세로 재진행 불가능 (과세처리 진행)</span>
				</div>
				<h4 class="background-color">5. 주소(연락처) 동일 취하</h4>
				<div class="mt5 background-color">●	신청서 2건 이상의 총 합이 150$ 미만이나, 수취인 주소, 연락처, 통관부호가 동일한 경우 발생합니다. </div>
				<div class="mt5 mb10 background-color">●	신청서 물품을 여러 번에 나누어서 배송 시 기재된 수취인 정보 및 배송 스케줄을 참고하시어 이용하여 주시기 바랍니다. 
				<br><span class="color-grey">예) A신청서 수취인 ㅇㅇㅇ / 주소 : 서울시 B동 C호 = B신청서 수취인 ㅁㅁㅁ / 주소 : 서울시 B동 C호</span>
				</div>
				<h4 class="background-color">6. 통관 부호 불일치</h4>
				<div class="mt5 background-color">●	최초 목록 통관 접수 시 통관부호 발급 받으신 성함, 연락처, 통관부호 중 1개라도 일치하지 않는 경우 발생됩니다.</div>
				<div class="mt5 background-color">●	신청서 수취인 작성 시 반드시 통관부호 발급 받으셨던 정보와 동일하게 기재하여 주시기 바라며,
				<br>핸드폰 번호가 변경된 경우 통관부호를 재발급 또는 핸드폰 인증을 새롭게 하셔야 합니다.
				</div>
				
				<h5 class="mb20" style="padding:20px 0 10px;">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12ZM18.045 7.455C17.9379 7.34823 17.8103 7.26416 17.6699 7.20782C17.5295 7.15149 17.3792 7.12404 17.228 7.12712C17.0768 7.1302 16.9277 7.16375 16.7897 7.22575C16.6518 7.28776 16.5277 7.37695 16.425 7.488L11.2155 14.1255L8.076 10.9845C7.86274 10.7858 7.58067 10.6776 7.28922 10.6827C6.99776 10.6879 6.71969 10.8059 6.51357 11.0121C6.30745 11.2182 6.18938 11.4963 6.18424 11.7877C6.1791 12.0792 6.28728 12.3612 6.486 12.5745L10.455 16.545C10.5619 16.6517 10.6892 16.7358 10.8294 16.7923C10.9695 16.8487 11.1196 16.8764 11.2706 16.8736C11.4217 16.8708 11.5706 16.8376 11.7085 16.776C11.8465 16.7144 11.9706 16.6256 12.0735 16.515L18.0615 9.03C18.2656 8.81775 18.3784 8.53391 18.3756 8.23944C18.3728 7.94496 18.2546 7.66332 18.0465 7.455H18.045Z" fill="#274A80"></path>
					</svg>
					<div class="content">공통사항</div>
				</h5>
				<div class="mt5 background-color">●	목록 통관 취하 수수료 2,000원 + 간이통관 수수료 3,000원(사업자 통관 시 수수료 18,000원) + (통관장 창고 관리비) 포장당 1,500원</div>
				<div class="mt5 background-color">●	관부가세 발생 실비</div>
				<div class="text-box tax" style="margin:10px 0 30px;">
					<h6 style="font-size: 17px;padding-left: 20px;">관부가세</h6>
					<ul class="dot-list">
						<li>●	사유서 내용 인정 시 : 미발생</li>
						<li>●	사유서 내용 인정 안될 시 : 실비</li>
						<li>●	개인 $2000 초과 시 관세사 수수료 11,000원으로 변경 청구됩니다.</li>
					</ul>
				</div>
				
				<h5 class="mb10">
					<span class="num">04.</span>
					<div class="content">수입금지 안내</div>	
				</h5>
				<div class="mt5 background-color">●	수입금지,통관불가,선적금지 품목의 구매/배송을 하여서 발생하는 모든 책임은 회원님에게 있습니다</div>
				<div class="mt5 background-color">●	회원님께서 작성하신 신청서를 세관에 제출하여 통관을 합니다.</div>
				<div class="mt5 background-color">●	신청서는 정확하게 작성하여야 하며, 허위/불성실 신고로 인한 모든 책임은 작성자 본인에게 있습니다.</div>
				<div class="mt5 background-color">●	안내드리는 수입금지 품목은 일부이며 이외에도 더 많은 수입금지 품목이 있습니다.</div>
				<div class="mt5 background-color">●	수입가능 여부에 대해서는 꼭 상품 구입 전 관세청/인천세관/식약청 등 관계기관 을 통해 직접 확인 후 구매해 주시기 바랍니다.</div>
		
				<h5 class="mb10" style="margin-top: 30px;">
					<span class="num">05.</span>
					<div class="content">통관불가 품목</div>	
				</h5>
				<div class="mt5 main-color">●	<strong>야생 동물/식물 (씨앗, 양곡, 식물종자, 식량작물종자, 채소종자포함)</strong></div>
				<div class="mt5 main-color">●	<strong>금은괴 및 통화</strong></div>
				<div class="mt5 main-color">●	<strong>위험품목, 석면포(방화커튼)을 포함하여 위험하거나 가연성이 있는 품목</strong></div>
				<div class="mt5 main-color">●	<strong>불법의약품 및 마취제</strong></div>
				<div class="mt5 main-color">●	<strong>화기, 병기 및 부품들(권총, 소총, 화약, 폭약, 화공품, 분사기, 전기충격기, 석궁</strong></div>
				<div class="mt5 main-color">●	<strong>준 무기류(도검, 서바이벌 게임용 총기완구, 사용한 총 포탄류, 군수물자)</strong></div>
				<div class="mt5 main-color">●	<strong>인체의 일부</strong></div>
				<div class="mt5 main-color">●	<strong>성인용품, 음란비디오, 서적, 사진 등 사회풍기문란 저해품목</strong></div>
				<div class="mt5 main-color">●	<strong>알코올 함량이 높은 가연성 향수, 스프레이식 화장품류 등</strong></div>
				<div class="mt5 main-color">●	<strong>수표, 현금과 같은 화폐(유가증권)</strong></div>
				<div class="mt5 main-color">●	<strong>화폐, 채권 기타 유가 증권의 위조품, 변조품, 모조품 등</strong></div>
				<div class="mt5 main-color">●	<strong>다량의 식품류(식용 천일염)</strong></div>
				<div class="mt5 main-color">●	<strong>가공(열처리)처리가 안 된 농산물</strong></div>
				<div class="mt5 main-color">●	<strong>다량의 화장품류, 액상비누류</strong></div>
				<div class="mt5 main-color">●	<strong>식품의약품안정청의 수입불허 도는 유해 의약품(취급제한 유독물)</strong></div>
				<div class="mt5 main-color">●	<strong>핵, 방사선 물질 및 장치</strong></div>
				<div class="mt5 main-color">●	<strong>의료기기</strong></div>
				<div class="mt5 main-color">●	<strong>코코넛, 코코넛 제품</strong></div>
				<div class="mt5 main-color">●	<strong>상표권을 침해하는 제품</strong></div>
				<div class="mt5 main-color">●	<strong>세관이 수량/중량/검사 조건을 제한한 품목의 기준이 초과한 화물을 포함</strong></div>
				<span>Bio Cell Collagen II (소해면상뇌증 관련품목으로 콜라겐(젤라틴))</span>
				<div class="mt5 main-color">●	<strong>화장품 중에 ACNE (free, anti) 등 단어가 반영된 화장품</strong></div>
				<span>(실리실산은 salicylic acid 또는 beta hydroxy acid, 벤조일퍼 옥사이드는 benzoyl peroxide)</span>
				<div class="mt5 main-color">●	<strong>이외 의 품목은 관계기관에 직접 문의하여 주시기 바랍니다</strong></div>
				
				<h5 class="mb10" style="margin-top: 30px;">
					<span class="num">06.</span>
					<div class="content">선적불가 품목</div>	
				</h5>
				<div class="mt5 background-color"><span class="main-color">●</span>	스프레이타입의 가스 충전식 제품</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	알코올 함량이 높은 가연성 향수</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	화기성 물품</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	페인트</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	드라이아이스</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	폭발 위험이 있는 물품 (석유난로, 알코올, 가스관련 제품)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	소다 스트림 실린더</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	배터리</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	기타 폭발 화기 가능성이 있는 모든 제품</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	매니큐어 및 손톱 강화제, 디퓨저 용액, 전기면도기 세척액 등 화기성 표시가 있는 제품은 항공기 선적 불가합니다.</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	중국의 경우 배터리가 내장되어 있는 제품도 선적 불가입니다. (태블릿 PC, 핸드폰, 스피커, 장난감 등)
				<br>또한 액체류, 식품류, 분말류도 항공기 선적이 불가합니다.
				</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	리튬배터리가 포함된 다이슨 청소기와 스마트폰, 냉매체와 실린더가 포함된 냉장고는 선적이 불가합니다.</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	냉장고(냉장고 냉매체, 실린더 포함)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	총기 모형 제품, 총기 모형 부품, 총기 장착 악세서리(조준경, 도토사이트), 모의 총포류, 장난감 총, 검, 활 등 무기류 (플라스틱 재질 포함)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	단독 배터리 종류 (보조배터리 제품 포함)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	스프레이타입의 가스 충전식 제품</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	전자담배 (액상포함)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	마스크 제품 전체(KN, 방진, 패션 마스크 등 모든 마스크품목 해당)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	손소독제, 체온계</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	기타요건면제 추천서가 없는 전자 의료기기 제품 (콘텍트 렌즈 포함)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	의약품(마약, 향전신성 의약품, 마취제, 불법적 의약품) 및 의료기기, 바늘</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	인화성,화학성 액체, 분말, 각종 분말 포함된 상품</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	나무원목</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	화약, 폭약류(불꽃놀이)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	고압가스 포함 제품류 (스프레이,부탄가스,소화기 등)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	가연성물질,폭발물류 등 (성냥, 숯 등)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	독극물류 (살충제, 농약류 등)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	방사성물질</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	생화학물질</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	대용량 액체화학류 (화장품,치약,알코올 등)</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	금은괴, 금, 은으로 제작된 악세서리, 제품 등</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	통화수표, 채권, 현금과 같은 화폐, 유가증권의 위조품, 변조품, 모조품 등</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	성인용품, 포르노그래피, 풍속저해품</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	동물, 식물, 인체의 일부</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	갈륨, 게르마늄, 안티몬, 텅스텐, 중·중희토류 등 전략 광물/div>
				<div class="mt5 background-color"><span class="main-color">●</span>	전동차, 전기 자전거, 전기 오토바이 등 배터리 장착된 모든 제품</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	국제법 위반상품 및 한,중 양국의 법 위반 상품</div>
				<div class="mt5 background-color"><span class="main-color">●</span>	추가되는 선적불가 품목은 공지사항으로 안내드리겠습니다</div>
				
				<h5 class="mb10" style="margin-top: 30px;">
					<span class="num">07.</span>
					<div class="content">검역</div>	
				</h5>
				<h6 class="mb10" style="font-weight: 700;font-size: 17px;">1. 식품 - 가공 육류(육포/유제품)</h6>
				<div class="mt5"><span class="main-color">●</span>	허용량 이상의 가공 농산물은 검역 필요</div>
				<div class="mt5"><span class="main-color">●</span>	성분 중에 닭, 소고기, 돼지 등의 동물의 몸체 중 일부분이 들어간 성분</div>
				<h6 class="mb10" style="font-weight: 700;font-size: 17px;">2. 애완동물 사료 및 보조식품 - 반추동물의 뼈, 뿔 등(원피 및 우유 제외)</h6>
				<div class="mt5"><span class="main-color">●</span>	동물성 가공 단백질 제품: 육골분, 육분, 골분, 발굽분, 건조혈장, 각분, 기타 혈액제품, 가수분해 단백질</div>
				<div class="mt5"><span class="main-color">●</span>	가금 설육분(poultry offal meal) 우모분 (feather meal), 건조 굳기름, 어분, 제2인산칼슘</div>
				<div class="mt5"><span class="main-color">●</span>	젤라틴 및 혼합물 (상기물품이 혼합된 사료, 사료 첨가제, premixture등)</div>
				
				<el-row class="mb50">
					<el-col :xs="24" :sm="12">
						<div class="organization">
							<div>관세청</div><div>1577-8577</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="12">
						<div class="organization">
							<div>인천본부세관</div><div>032-722-4114</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="12">
						<div class="organization">
							<div>인천공항본부세관</div><div>032-740-2700</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="12">
						<div class="organization">
							<div>식품의약품안전처</div><div>1577-1255</div>
						</div>
					</el-col>
				</el-row>
				<p class="text-center mb20" >해외 수입/직구 시 통관 가능 여부는 사전에 관계 기관으로 직접 문의 하셔야 합니다.</p>
			
				<div class="btn-wrap">
					<div class="link-btn dark" @click="goCustomsinfoUrl('https://impfood.mfds.go.kr/CFCII01F01')">
						 수입금지 성분목록 확인하기 <i class="el-icon-top-right"></i>
					</div>
				</div>
			
				<div class="divided-line type-solid visible-xs"></div>
				
				<ul class="check-list">
					<li>회원님께서 작성하신 신청서를 세관에 제출하여 통관을 합니다.</li>
					<li>신청서는 정확하게 작성하여야 하며, 허위신고로 인한 모든 책임은 작성자 본인에게 있습니다.</li>
				</ul>
			
			</div>
			
			</div>
		</div>
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	export default {
		components: {
			PersonalBanner
		},
		data() {
			return{
				
			}
		},
		methods: {
			goCustomsinfoUrl(url){
				window.open(url, '_blank');
			},
		
		}		
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.type-card{
		border-radius: 20px;
		background: #FFFFFF;
		border: 1px solid #E8E8E8;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
		padding:40px;
		margin:0 10px;
	}
	.type-card h5{

		font-size: 20px;
		display: flex;
	}
	.type-card h5 .num{
		color:var(--main-color);
	}
	
	table.table-form {
	    width: 100%;
	    padding: 0;
	    border-spacing: 0;
	    border-collapse: collapse;
	    table-layout: fixed;
	    margin: 40px 0 70px;
		color:var(--background-color)
	}


	table.table-form tr td{
		padding:20px 10px;
	}
	ul.dot-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	table.table-form th {
		text-align: left;
		padding-top: 13px;
		padding-left: 10px;
		background-color: #f5f8fd;
		font-weight: bold;
	}
	table.table-form th, table.table-form td {
		padding: 10px 10px 10px 15px;
		vertical-align: middle;
		border: solid 1px var(--border-color);
		border-width: 1px 0;
		word-break: break-all;
		font-size: 17px;
	}
	.card-body{
		margin: 50px auto;
		background: #FFFFFF;
		color: var(--background-color);
		border: 2px solid #E8E8E8;
		border-radius: 20px;
		padding: 50px;
		font-size: 15px;
		line-height: 1.6;
	}
	.card-body h6{
		margin-top: 0;
		font-weight: 700;
		font-size: 17px;
	}
	.mt5{
		padding: 5px 0;
	}
	.text-box {
	    background: #D5E6FA;
	    border-radius: 20px;
	    font-weight: 600;
	    color: #274A80;
	    line-height: 1.6;
	    padding: 25px;
	}
	.text-box.tax {
	    padding: 20px;
	    background: #F4F8FF;
	    color: #333;
	    font-weight: 400;
	}
	.process-wrap {
	    padding: 30px;
	    background: #F4F8FF;
	    border-radius: 20px;
	    color: #274A80;
	}
	.process-wrap .process.step-6 {
	    grid-template-columns: repeat(3, 1fr);
	}
	.process-wrap .process.step-5 {
	    grid-template-columns: repeat(5, 1fr);
	}
	.process-wrap .process.step-4 {
	    grid-template-columns: repeat(4, 1fr);
	}
	.process-wrap .process {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	    display: grid;
	    gap: 10px 40px;
	}
	.process-wrap .process li {
	    background: #fff;
	    min-height: 100px;
	    padding: 14px 10px;
	    border: 1px solid #C1D0E7;
	    border-radius: 10px;
	    display: flex;
	    flex-wrap: wrap;
	    flex-direction: column;
	    align-items: center;
	    justify-content: center;
	    position: relative;
	}
	.process-wrap .process li .step {
	    width: 56px;
	    line-height: 24px;
	    background: #274A80;
	    border-radius: 40px;
	    font-weight: 500;
	    font-size: 12px;
	    color: #fff;
	    text-align: center;
	    margin-bottom: 10px;
	}
	.process-wrap .process li p {
	    font-weight: 500;
	    font-size: 15px;
	    line-height: 18px;
	    text-align: center;
	    color: var(--navy-color);
	    margin-bottom: 0;
	}
/* 	.process-wrap .process li:after {
	    content: '';
	    display: block;
	    width: 22px;
	    height: 16px;
	    position: absolute;
	    top: 50%;
	    margin-top: -8px;
	    right: -32px;
	    background: url('../../assets/icon/ico_customs_process_arrow.png') no-repeat 0 0;
	} */
	.type-card .content{
		padding:0 0 0 10px;
		color: var(--background-color);
	}
	ul.dot-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	ul.dot-list > li {
	    padding-left: 16px;
	    line-height: 30px;
	    position: relative;
	}
	.organization{
		margin: 10px;
		font-weight: bold;
		font-size: 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 100px;
		padding: 25px 15px;
		background: #FFFFFF;
		border: 2px solid #E8E8E8;
		border-radius: 20px;
	}
	.btn-wrap{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.link-btn{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 30px;
		font-weight: 600;
		font-size: 18px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 13px 28px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer
	}
	.dark{
		background: #303030;
		border-color: #303030;
		color: #fff;
	}
	ul.check-list {
	    margin: 50px 0 0;
	    padding: 0;
	    list-style: none;
	}
	ul.check-list li {
	    padding-left: 26px;
	    background: url('../../assets/ico_check_grey.svg') no-repeat left 2px top 4px;
	    font-weight: 400;
	    font-size: 14px;
	    line-height: 23px;
	}

	.mb10{
		margin-bottom: 20px !important;
	}
	.mb20 {
	    margin-bottom: 20px !important;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	.text-center {
	    text-align: center !important;
	}
	.color-grey {
	    color: #6A6A6A;
	}
	.main-color{
		color: var(--main-color);
	}
	.visible-xs {
	    display: none !important;
	}
	.divided-line {
	    border-top: 1px dashed var(--border-color);
	    margin: 26px 0;
	}

	.type-card .divided-line.type-solid {
	    border-top-style: solid;
	}
	.background-color{
		color:var(--background-color)
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.type-card{
			padding:40px 10px;
			margin-bottom: 30px;
		}
		.card-body{
			padding: 50px 10px;
		}
		.process-wrap .process.step-6, .process-wrap .process.step-4, .process-wrap .process.step-5 {
			grid-template-columns: repeat(1, 1fr);
			gap: 40px;
		}

		
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
</style>